module.exports = __webpack_public_path__ + "components/home-header/static/header-2--large@2x-27598032f5ddf1d112558c770f6e9866.jpg";